import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	categoriesHeader: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.categories-header',
		defaultMessage: 'Categories',
		description: 'Header for the categories column in an article table',
	},
	noCategoriesTooltip: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-tooltip',
		defaultMessage:
			'Categories are not available for spaces linked from Confluence Data Center sites.',
		description:
			'Header for the categories tooltip in an articles table column, explains that categories are not supported when integrating with Confluence server.',
	},
	noCategoriesRow: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-row',
		defaultMessage: 'Not available.',
		description: 'Row for the categories column, explains that categories are not available.',
	},
	updateCategoriesHeader: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.update-categories-header',
		defaultMessage: 'Categories',
		description: 'Header for the updating categories column in an article table',
	},
	linkedSpacesHeader: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.linked-spaces-header',
		defaultMessage: 'Space',
		description: 'Header for the linked spaces in the table',
	},
	tooltipText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.tooltip-text',
		defaultMessage: 'Opens in new tab',
		description: 'tooltip text for spaces column',
	},
});
